import {AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {FileManager} from "../../../../shared/interface/file-manager";
import {concat, Observable, ReplaySubject} from "rxjs";
import {MatDialogRef} from "@angular/material/dialog";
import {MatSnackBar} from "@angular/material/snack-bar";
import {FormHelperService} from "../../../../shared/services/form-helper.service";
import {FileManagerService} from "../../../../shared/services/file-manager.service";
import {NgxImageCompressService} from "ngx-image-compress";
import {filter, takeUntil, tap} from "rxjs/operators";
import {FileInput} from "ngx-material-file-input";
import {HttpErrorResponse} from "@angular/common/http";
import {SharedFileService} from "../../../../shared/services/shared-file.service";
import {FileResult} from "../../../../shared/components/file-drag-and-drop/file-drag-and-drop.component";

@Component({
  selector: 'app-shared-file-add',
  templateUrl: './shared-file-add.component.html',
  styleUrls: ['./shared-file-add.component.scss']
})
export class SharedFileAddComponent implements OnInit, OnDestroy, AfterViewInit {

  expirationOptions = [
    { label: '1 dzień', value: 1 },
    { label: '3 dni', value: 3 },
    { label: '7 dni', value: 7 },
  ];

  processingRequest = false;
  sharedFileForm: FormGroup;
  fileNameControl: FormControl;
  passwordControl: FormControl;
  nameControl: FormControl;
  expirationDaysControl: FormControl;
  fileControl: FormControl;
  file?: FileManager;
  formErrors: any = {};
  fileResults: FileResult[] = [];
  maxSize = 500 * 1024 * 1024;
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  private initialized: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    public dialogRef: MatDialogRef<SharedFileAddComponent>,
    private fb: FormBuilder,
    private snack: MatSnackBar,
    private formHelper: FormHelperService,
    private sharedFileService: SharedFileService,
    private imageCompress: NgxImageCompressService,
  ) {
    this.fileControl  = fb.control('', [Validators.required]);
    this.sharedFileForm = this.fb.group({
      name:  this.nameControl = this.fb.control('', [Validators.required]),
      password: this.passwordControl = fb.control( '' ),
      expirationDays: this.expirationDaysControl =  fb.control( 3, [Validators.required]),
    });
  }

  ngOnInit(): void {
    this.fileControl.valueChanges
      .pipe(
        takeUntil(this.destroyed$),
        filter((file?: File[]) => !!file)
      )
      .subscribe(() => {
        this.fileResults = [];
      });
  }

  ngAfterViewInit(): void {
    // if (this.file) {
    //   this.initialize(this.file);
    // } else {
    //   this.initialized.next(true);
    // }
  }

  sendForm(): void {
    if ( !this.sharedFileForm.valid)
    {
      this.sharedFileForm.markAllAsTouched();
      this.snack.open('Wypełnij lub popraw wszystkie wymagane pola', '', {
        duration: 2000,
      });
      return;
    }
    this.processingRequest = true;

    this.formErrors = {};
    this.fileResults = [];

    this.sharedFileService.send(this.sharedFileForm.value)
      .subscribe((response) => {
        this.processingRequest = true;
        const forms: Observable<any>[] = [];
        let lenth = 0;
        this.fileControl.value?.forEach((file: File) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => {
            forms.push(this.sharedFileService.add(response.uuid, {
              fileContent: (/base64,(.+)/.exec(reader.result.toString())[1]),
              fileName: file.name,
            }).pipe(
              tap((as) => {
                this.fileResults.push({
                  file,
                  result: true,
                });
                lenth ++;

                if (lenth === this.fileControl.value?.length  )
                {
                  this.snack.open('Pomyślnie dodano pliki', '', {
                    duration: 2000,
                  });
                  this.processingRequest = false;
                  this.dialogRef.close();
                }
              }, (error: HttpErrorResponse) => {
                this.fileResults.push({
                  file,
                  result: false
                });
              }),
            ));

            if (forms.length === this.fileControl.value?.length) {
              concat(...forms)
                .subscribe(() => {
                  }, (error: HttpErrorResponse) => {
                  this.processingRequest = false;
                  this.snack.open('Przy wczytywaniu pliku wystąpił błąd', error.status.toString(), {duration: 2000});
                });
            }
          };
        });

      }, (error: HttpErrorResponse) => {
        this.processingRequest = false;
        this.snack.open('Podczas dodawania polisy wystąpił błąd', error.status.toString(), {
          duration: 2000,
        });
        if (error.status === 400) {
          this.formErrors = error.error.error.list;
          this.formHelper.setBackendErrorState(this.sharedFileForm, this.formErrors);
        }
      })
    ;
  }

  closeDialog(e): void {
    this.dialogRef.close(e);
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
  expirationOptionsUnlock(e): void {
    if (e){
      this.expirationOptions.push( { label: 'Bez Limitu', value: 0 });
    } else{
      this.expirationOptions = this.expirationOptions.filter(opt => opt.value !== 0);
    }

  }
}
